import { render, staticRenderFns } from "./DemoTracks.vue?vue&type=template&id=7b011143&scoped=true&"
import script from "./DemoTracks.vue?vue&type=script&lang=js&"
export * from "./DemoTracks.vue?vue&type=script&lang=js&"
import style0 from "./DemoTracks.vue?vue&type=style&index=0&id=7b011143&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b011143",
  null
  
)

export default component.exports